import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';
import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getPortsUrl = (params) => `/api/Ports${getQueryParams(params)}`;
export const getPorts = (params) => makeRequest(authFetch.get(getPortsUrl(params)));
export const useGetPorts = (params, opts = {}) => useQuery([getPortsUrl(params)], () => getPorts(params), { ...CacheConfig.forever, ...opts });

export const getPortLookups = (params) => makeRequest(authFetch.get(`/api/Ports/Lookup${getQueryParams(params)}`));

export const postPort = async (data) => {
  try {
    const response = await authFetch.post('/api/Ports', data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getContinents = async () => {
  try {
    const response = await authFetch.get('/api/Ports/Continents');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
